import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';



import {
  APP_STORAGE_USERNAME,
  APP_STORAGE_FIRSTNAME,
  APP_STORAGE_REMEMBERME,
  DataService,
  NonComplianceSummary, ServerConstantsService
} from '../shared';
import { CommonUtility, AuthService } from '../shared';
import { TokenStorage } from '../shared/Utility/TokenStorage';
import { ReferenceTableService } from '../reference-table.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AuthService]
})
export class LoginComponent implements OnInit {
  @ViewChild('emailField') emailField: ElementRef;
  @ViewChild('emailMsg') emailMsg: ElementRef;
  /* Route params */

  /* Page models */
  username: string;
  password: string;
  rememberMeSw = false;
  /* Miscellaneous */
  loginFailed = false;
  baseLine: any;
  userActionNotificationsMap: any;
  showFlag:Boolean;
  ServerConstants: any;
  buildConstants:any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private titleService: Title,
    private commonUtil: CommonUtility,
    private authService: AuthService,
    private dataService: DataService,
    private tokenStorage: TokenStorage,
    private data: ReferenceTableService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private idle: Idle,
    private keepalive: Keepalive
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.buildConstants = serverConstantsService.getBuildConstants();
  }

  ngOnInit() {
    // If authenticated, redirect to dashboard page
    /*this.emailMsg.nativeElement.classList.remove('d-block');
    this.emailMsg.nativeElement.classList.add('d-none');*/
    if(this.dataService.isWorker === true){
      this.router.navigate(['SNAPWorks/workerportal']);
    }
    else{
      this.dataService.isWorker = false;
    }
    this.showFlag = false;
    this.idle.stop();
    this.baseLine = this.buildConstants.BUILD_NUMBER + '  :  ' + this.buildConstants.BUILD_TIME;
    if (sessionStorage.getItem('FirstName')) {
      this.router.navigate(['dashboard']);

    }

    // Retrieve username from session storage
    if (window.localStorage.getItem(APP_STORAGE_REMEMBERME) === 'Y') {
      this.rememberMeSw = true;
      this.username = window.localStorage.getItem(APP_STORAGE_USERNAME);
    }
  }

  openForgortPassword() {
    this.router.navigate(['forgotPassword']);

  }

  // Process login
  processLogin() {
    this.validateEmail();
    // Remove login error message
    if(this.showFlag == false){
    this.showFlag = false;
    this.loginFailed = false;

    // If Remember Me is enabled, persist 'username' in session
    if (this.rememberMeSw === true) {
      window.localStorage.setItem(APP_STORAGE_REMEMBERME, 'Y');
    } else {
      window.localStorage.removeItem(APP_STORAGE_REMEMBERME);
    }

    this.dataService.addValueToSharedDataMap('username', this.username);

    // Generate input load
    const inputLoad = { 'username': this.username, 'password': this.password,'isLDAPAuthenticated':'N' };

    // POST Call: Retrieve token from backend
    this.authService.attemptAuth(inputLoad).subscribe(data => {
      if (data.token) {
        console.log(data);
        // Persist session (i.e. post-authentication response)
        this.dataService.addValueToSharedDataMap('token', data.token);
        this.authService.signIn(data);
        sessionStorage.setItem('FirstName', data.firstName);
        // this.data.firstName.next(sessionStorage.getItem('firstName'));
        this.dataService.addValueToSharedDataMap('current_user_full_name', data.firstName + ' ' + data.lastName);
        this.dataService.addValueToSharedDataMap('firstName', data.firstName);
        this.dataService.addValueToSharedDataMap('lastName',  data.lastName);
        this.dataService.addValueToSharedDataMap('current_user', data.username);
        this.dataService.addValueToSharedDataMap('tempPasswordSw', data.tempPasswordSw);
        this.dataService.addValueToSharedDataMap('expirationSw', data.expirationSw);
        // Retrieve reference tables
        this.data.loadData();
        this.data.currentMessage.subscribe(
          (message) => {
            this.data.parseRefTableData(message);
          });
        // Retrieve page roles
        this.dataService.loadPageRolesData();
        this.idle.watch();

        if (data.expirationSw) {
          this.notificationService.warn('Login', 'Your current password expired.');

        }
        // Redirect to dashboard
        if (data.tempPasswordSw === 'Y' || (data.expirationSw)) {
          this.dataService.removeValueFromSharedDataMap('token');
          sessionStorage.removeItem('FirstName');
          this.router.navigate(['reset']);

        } else {

          this.router.navigate(['dashboard']);
        }

      } else {
        this.loginFailed = true;
      }
    }, response => {
      this.loginFailed = true;
    }, () => {

    });
  }
  }


  /**
   * 
   * @param event Process login when 'Enter' key is pressed
   */
  onEnterSubmit(event: KeyboardEvent){
    const KEY_ENTER = 13;

    if(event.keyCode != KEY_ENTER){
      return;
    }
    
    event.preventDefault;
    document.getElementById('loginBtn').click();
  }
  validateEmail() {
   
    const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.username !== null && this.username !== undefined) {
      if (!regExp.test(String(this.username).toLowerCase())) {
        this.showFlag = true;
        this.emailField.nativeElement.classList.remove('ng-valid');
        this.emailField.nativeElement.classList.add('ng-invalid');
        /*this.emailMsg.nativeElement.classList.add('d-block');
        this.emailMsg.nativeElement.classList.remove('d-none');*/
        this.loginFailed = false;
        return false;
      } else {
        this.showFlag = false;
        this.emailField.nativeElement.classList.remove('ng-invalid');
        this.emailField.nativeElement.classList.add('ng-valid');
        /*this.emailMsg.nativeElement.classList.remove('d-block');
        this.emailMsg.nativeElement.classList.add('d-none');*/
        return true;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts